import React from 'react';
import classnames from 'classnames';
import { useMemoizedFn } from 'ahooks';
import { Modal, Button, ButtonProps } from 'tea-component';
import { BoolFlag, reverseBoolFlag } from '@gp/enums/common';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IStateCfg<T = string> {
  active: T;
  deactive: T;
}

interface IConfirmCfg {
  title: string;
  // description: string;
}

interface IPublishButtonProps extends IBaseProps, Omit<ButtonProps, 'children' | 'value' | 'onChange'> {
  value: BoolFlag;
  onChange?: (payload: BoolFlag) => void;
}

const PUBLISHED_TEXTS: IStateCfg = {
  active: 'Take Down Newsletter',
  deactive: 'Publish Newsletter',
};

const PUBLISHED_CONFIRM_CFG: IStateCfg<IConfirmCfg> = {
  active: {
    title: 'Do you want to take down this newsletter?',
    // description: 'The weekly report will be unpublished once you click confirm!',
  },
  deactive: {
    title: 'Do you want to publish this newsletter?',
    // description: 'The weekly report will be published once you click confirm!',
  },
};

const getInfo = (value: BoolFlag): { text: string; confirmCfg: IConfirmCfg } => {
  const stateField = value === BoolFlag.True ? 'active' : 'deactive';
  const text = PUBLISHED_TEXTS?.[stateField] || '';
  const confirmCfg = PUBLISHED_CONFIRM_CFG?.[stateField];
  return { text, confirmCfg };
};

const PublishButton: React.FC<IPublishButtonProps> = (props) => {
  const { style, className, value, onChange, ...restProps } = props;

  const { text, confirmCfg } = getInfo(value);

  const handleClick = useMemoizedFn((e?: React.SyntheticEvent) => {
    e?.stopPropagation();
    Modal.confirm({
      className: 'dbg-confirmable-confirm-modal',
      message: confirmCfg?.title || '',
      // description: confirmCfg?.description || '',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        const valueTmp = reverseBoolFlag(value);
        onChange?.(valueTmp);
      },
      onCancel: () => {},
    });
  });

  return (
    <Button
      {...restProps}
      style={style}
      className={classnames('dbg-publish-btn dbg-common-iconbtn', className)}
      onClick={handleClick}
    >
      {text}
    </Button>
  );
};

export default React.memo(PublishButton);
